<script setup lang="ts">
import { useTemplateRef, ref, watch, nextTick } from 'vue';
import OverlayPanel from 'primevue/overlaypanel';

const props = defineProps<{
  field: any;
}>();

const extraInfoPanel = useTemplateRef<InstanceType<typeof OverlayPanel> | null>('extraInfoPanel');
const textElement = useTemplateRef<HTMLParagraphElement | null>('textElement');

const isHovering = ref(false);
const isOverflowing = ref(false);

watch(() => props.field, checkOverflow, { immediate: true });

function checkOverflow() {
  nextTick(() => {
    if (!textElement.value) return;

    isOverflowing.value = textElement.value.scrollWidth > textElement.value.clientWidth;
  });
}

function showPanel(event: any) {
  if (!isOverflowing.value) return;

  isHovering.value = true;
  extraInfoPanel.value?.show(event);
}

function hidePanel() {
  setTimeout(() => (!isHovering.value ? extraInfoPanel.value?.hide() : ''), 100);
}
</script>

<template>
  <div
    v-if="field"
    :class="[
      'flex items-center gap-2 overflow-hidden truncate text-ellipsis whitespace-nowrap',
      isOverflowing ? 'cursor-context-menu justify-between' : '',
    ]"
    @mouseenter="showPanel"
    @mouseleave="
      isHovering = false;
      hidePanel();
    "
  >
    <p
      class="!h-5 w-max max-w-[200px] overflow-hidden truncate text-ellipsis text-sm"
      ref="textElement"
      v-html="field"
    ></p>

    <i
      v-if="isOverflowing"
      class="pi pi-eye text-sm text-slate-500"
    ></i>

    <OverlayPanel
      v-if="isOverflowing"
      ref="extraInfoPanel"
      @mouseenter="isHovering = true"
      @mouseleave="
        isHovering = false;
        hidePanel();
      "
    >
      <div class="flex gap-2 border-t py-1 text-sm first:border-t-0 first:pt-0 last:pb-0">
        <p
          class="max-h-[450px] max-w-[300px] overflow-auto whitespace-pre-line text-sm"
          v-html="field"
        ></p>
      </div>
    </OverlayPanel>
  </div>

  <p v-else>-</p>
</template>
